import { ICON__plus } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';

interface PROPS {
  field: FIELD__list_token;
}

export function G_BUTTON__add_special_tokens({ field }: PROPS) {
  const dispatch = use_dispatch();
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_general__field_to_add_special_tokens', field }));
  }
  /*
   *
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-bar"
      size="rect-10-5"
      iconClassNameBase="!text-component-item-foreground !size-3"
      iconClassNameHovered="!text-bar-foreground"
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={ICON__plus}
      disabled={is_disabled()}
      {...{ onClick }}
    ></UI_PRIMITIVE__button_with_icon_animated>
  );
}
